import { groupBy, keyBy, mapValues, sortBy } from "lodash";
import { AccessPointProcessingStep, ImportConfigurationGroupResponse, ImportConfigurationStepResponse } from "../models";
import { ImportGroupState, ImportStepState } from "../state";

export const mapGroupsState = (groups: ImportConfigurationGroupResponse[]): { [group: string]: ImportGroupState } => {
  const steps = groups.map((g) => mapValues(groupBy(sortBy(g.steps, "name"), "operation"), (ops) => ops.map((s) => s.stepType)));
  const groupState = groups.map((g, i) => ({
    appendSteps: steps[i].Append,
    dirty: false,
    filterSteps: steps[i].Filter,
    group: g.groupType,
    name: g.name,
    querySteps: steps[i].Query,
    transformSteps: steps[i].Transform,
    validateSteps: steps[i].Validate,
  }));
  return keyBy(groupState, "group");
};

export const mapStepsState = (groups: ImportConfigurationGroupResponse[]): { [step: string]: ImportStepState } => {
  return groups.reduce((acc, group) => ({
    ...acc,
    ...keyBy(group.steps, (step: ImportConfigurationStepResponse) => step.stepType),
  }), {} as { [step in AccessPointProcessingStep]?: ImportStepState });
};
